import React, { useState, useEffect } from "react";
import TextInput from "../../fields/TextInput";
import { useNavigate } from "react-router-dom";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { cleanupreset, resetPassword } from "../../../redux/Slice/authSlice";
import { ClipLoader } from "react-spinners";

const Index = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const forgetPW = useSelector((state) => state?.auth?.forgetpwEmail);
  const resetDetail = useSelector((state) => state?.auth?.resetDetail);
  const resetStatus = useSelector((state) => state?.auth?.resetStatus);
  const [changePwDetail, setChangePwDetail] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newpwErr, setNewpwErr] = useState("");

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleInput = (event) => {
    const { name, value } = event.target;
    setChangePwDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const notify = (msg) => toast(`${msg}`);

  useEffect(() => {
    if (resetDetail?.success === true) {
      notify(resetDetail?.message);
      navigate("/login");
    }
  }, [resetDetail]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (changePwDetail.newPassword.length < 6) {
      setNewpwErr("Password must be six characters long");
    }

    if (changePwDetail.confirmPassword.length < 6) {
      setNewpwErr("Password must be six characters long");
    }
    if (changePwDetail.newPassword !== changePwDetail.confirmPassword) {
      setNewpwErr("Password doesn't match");
    }
    if (
      changePwDetail.newPassword.length < 6 ||
      changePwDetail.confirmPassword.length < 6 ||
      changePwDetail.newPassword !== changePwDetail.confirmPassword
    ) {
      return;
    } else {
      dispatch(
        resetPassword({
          password: changePwDetail?.newPassword,
          confirmPassword: changePwDetail?.confirmPassword,
          email: forgetPW,
        })
      );

      // navigate('/login')
      // notify()
    }
  };

  useEffect(() => {
    return () => {
      dispatch(cleanupreset());
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid px-0">
      <div className="slider_img ">
        <div className="row mx-0 z_999">
          <div className="col-lg-4 px-0">
            <div className="login-div mx-1">
              <h2 className="font accentColor">Reset Password?</h2>
              <div className="mt-2">
                <div className="mb-2">
                  <p className="accentColor fs14">
                    New Password <span className="text-danger">*</span>
                  </p>
                  <FormControl sx={{ width: "100%" }} variant="outlined">
                    <OutlinedInput
                      placeholder="********"
                      shrink="false"
                      animation="true"
                      name="newPassword"
                      value={changePwDetail.newPassword}
                      onChange={handleInput}
                      error={newpwErr}
                      size="small"
                      id="newPassword"
                      type={showConfirmPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? <IoMdEyeOff /> : <IoEye />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>

                  {/* <TextInput
                    type="password"
                    id="newPassword"
                    size="small"
                    name="newPassword"
                    value={changePwDetail.newPassword}
                    onChange={handleInput}
                    error={newpwErr}
                    helperText={newpwErr}
                    formPlaceholder="********"
                    shrink="false"
                    animation="true"
                    requiredStar={true}
                  /> */}
                </div>
                <div className="mb-2">
                  <p className="accentColor fs14">
                    Confirm Password <span className="text-danger">*</span>
                  </p>

                  <FormControl sx={{ width: "100%" }} variant="outlined">
                    <OutlinedInput
                      placeholder="********"
                      shrink="false"
                      animation="true"
                      name="confirmPassword"
                      value={changePwDetail.confirmPassword}
                      onChange={handleInput}
                      error={newpwErr}
                      size="small"
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <IoMdEyeOff /> : <IoEye />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                    <FormHelperText className="text-danger">
                      {newpwErr}
                    </FormHelperText>
                  </FormControl>
                </div>
                <p className="location-err">{resetDetail?.message}</p>
                <button
                  type="submit"
                  onClick={(e) => {
                    scrollToTop();
                    handleSubmit(e);
                  }}
                  className="btn w-100 grid-class img-btn mt-3 primaryColor"
                >
                  {resetStatus === "pending" ? null : "Reset"}
                  <ClipLoader
                    loading={resetStatus === "pending" ? true : false}
                    cssOverride={{ width: "25px", height: "25px" }}
                    color="#fff"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
